import {
  InsightTableGroupBy,
  InsightTableType,
} from 'modules/finance/components/FinancialWorkspace/types/table'

export const DEFAULT_CURRENCY = 'EUR'

const ITEMS_PER_PAGE = 10
const CUSTOM_ITEMS_PER_PAGE = 5

export const FIELD_MAP: Record<InsightTableGroupBy, string> = {
  // TODO: FIX Employee name sorting
  // When using cursor pagination with employee paginated data
  // Sorting by employee name does not work as expectaed because of the joins
  // with users_personal_infos and accesses tables.
  // The issues is not trivial to fix and requires a more work.
  // There was a similar issue here https://factorialmakers.atlassian.net/browse/FCT-21908
  employee: '',
  manager: '',
  location: 'location_name',
  legalentity: 'legal_entity_name',
  costcenter: 'cost_center_name',
  customcategory: 'custom_category_name',
  lineitem: '', // TODO: To be implemented
  total: '',
}

const excludeCustomItemPerPageGroupBy = [InsightTableGroupBy.LineItem]

export const resolveItemsPerPage = (type?: InsightTableType, groupBy?: InsightTableGroupBy) => {
  if (!type || !groupBy) return ITEMS_PER_PAGE

  return excludeCustomItemPerPageGroupBy.includes(groupBy) ? ITEMS_PER_PAGE : CUSTOM_ITEMS_PER_PAGE
}

export const stickyColumnProps: {
  position: 'left' | 'right'
  delimiter: boolean
} = {
  position: 'left',
  delimiter: true,
}

export const dashedRowProps = {
  backgroundImage: `repeating-linear-gradient(
    45deg,
    transparent,
    transparent 8px,
    #eee 5px,
    #eee 10px
  )`,
  backgroundSize: '100% 100px',
}

export type FieldMap = {
  [K in InsightTableGroupBy]: string
}

export const REFETCH_DATA_EVENT = 'fw_refresh_data'
